import Catalog from "@/pages/Catalog";

export default function RDBElectricCatalog() {
  return (
    <Catalog
      collectionFilter="RDB Electric"
      overline="RDB Electric"
      titleLine1="Κατάλογος"
      titleAccent="RDB Electric."
      subtitle="Το ηλεκτρικό μέλλον της οδήγησης. Ήσυχες, καθαρές, δυναμικές μηχανές RDB Electric."
    />
  );
}
